/**
 * Admin
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import {  HttpHeaders, HttpParams,
          HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { MissingTrackDiagrams } from '../model/missingTrackDiagrams';
import { PublicCourseDiagram } from '../model/publicCourseDiagram';
import { SaveArguments } from '../model/saveArguments';
import { TrackCourseDiagram } from '../model/trackCourseDiagram';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


import { JtHttp, HttpResponse } from '../../JtHttp';

@Injectable()
export class TrackDiagramsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: JtHttp, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param courseType 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAdminTrackDiagramsCourseDiagramsGet(courseType?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<PublicCourseDiagram>>;
    public apiAdminTrackDiagramsCourseDiagramsGet(courseType?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<PublicCourseDiagram>>>;
    public apiAdminTrackDiagramsCourseDiagramsGet(courseType?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<PublicCourseDiagram>>>;
    public apiAdminTrackDiagramsCourseDiagramsGet(courseType?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (courseType !== undefined && courseType !== null) {
            queryParameters = queryParameters.set('courseType', <any>courseType);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<PublicCourseDiagram>>('get',`${this.basePath}/api/Admin/TrackDiagrams/CourseDiagrams`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAdminTrackDiagramsDistancesGet(observe?: 'body', reportProgress?: boolean): Observable<{ [key: string]: Array<TrackCourseDiagram>; }>;
    public apiAdminTrackDiagramsDistancesGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<{ [key: string]: Array<TrackCourseDiagram>; }>>;
    public apiAdminTrackDiagramsDistancesGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<{ [key: string]: Array<TrackCourseDiagram>; }>>;
    public apiAdminTrackDiagramsDistancesGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<{ [key: string]: Array<TrackCourseDiagram>; }>('get',`${this.basePath}/api/Admin/TrackDiagrams/Distances`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAdminTrackDiagramsMissingGet(observe?: 'body', reportProgress?: boolean): Observable<Array<MissingTrackDiagrams>>;
    public apiAdminTrackDiagramsMissingGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MissingTrackDiagrams>>>;
    public apiAdminTrackDiagramsMissingGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MissingTrackDiagrams>>>;
    public apiAdminTrackDiagramsMissingGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<MissingTrackDiagrams>>('get',`${this.basePath}/api/Admin/TrackDiagrams/Missing`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAdminTrackDiagramsSavePost(body?: SaveArguments, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiAdminTrackDiagramsSavePost(body?: SaveArguments, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiAdminTrackDiagramsSavePost(body?: SaveArguments, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiAdminTrackDiagramsSavePost(body?: SaveArguments, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/Admin/TrackDiagrams/Save`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param trackId 
     * @param courseType 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAdminTrackDiagramsTrackDiagramsGet(trackId?: number, courseType?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<TrackCourseDiagram>>;
    public apiAdminTrackDiagramsTrackDiagramsGet(trackId?: number, courseType?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TrackCourseDiagram>>>;
    public apiAdminTrackDiagramsTrackDiagramsGet(trackId?: number, courseType?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TrackCourseDiagram>>>;
    public apiAdminTrackDiagramsTrackDiagramsGet(trackId?: number, courseType?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (trackId !== undefined && trackId !== null) {
            queryParameters = queryParameters.set('trackId', <any>trackId);
        }
        if (courseType !== undefined && courseType !== null) {
            queryParameters = queryParameters.set('courseType', <any>courseType);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<TrackCourseDiagram>>('get',`${this.basePath}/api/Admin/TrackDiagrams/TrackDiagrams`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
